import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { SftpImportConfigurationWorkflow, LibraryImportExistingInventoryModeType, LibraryImportNonSummaryRowsModeType } from '../../../store/Models/Api/SftpImportModels';
import { RadioButton } from '../../core/RadioButton';
import { DropdownMenu } from '../../core/DropdownMenu';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';

interface ImportLibrarySettingsPanelLocalProps {
    config: SftpImportConfigurationWorkflow;
}

type ImportLibrarySettingsPanelProps = ImportLibrarySettingsPanelLocalProps & ToxnotComponentProperties;

class ImportLibrarySettingsPanelComponent extends ToxnotComponent<ImportLibrarySettingsPanelProps> {
    render() {
        const { config } = this.props;
        
        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">{this.localizeString("Import Library Settings")}</h3>
                </div>
                <div className="panel-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <div className="form-group">
                        <h4>{this.localizeString("Conflict Resolution Strategy")}</h4>
                        <RadioButton
                            name={this.localizeString("Overwrite Existing Products/Materials with the Import")}
                            value={LibraryImportExistingInventoryModeType.OverwriteExisting}
                            selected={config.libraryImportExistingInventoryMode === LibraryImportExistingInventoryModeType.OverwriteExisting}
                            onValueChange={() => {}}
                            disabled={true}
                        />
                        
                        {config.libraryImportExistingInventoryMode === LibraryImportExistingInventoryModeType.OverwriteExisting && (
                            <div style={{ paddingLeft: '30px', marginTop: '10px' }}>
                                <div className="form-group">
                                    <label>{this.localizeString("Should existing summary rows be updated?")}</label>
                                    <DropdownMenu
                                        options={[
                                            { text: this.localizeString('Yes, update summary rows with new uploaded data.'), value: 'yes' },
                                            { text: this.localizeString('No, do not update summary rows.'), value: 'no' }
                                        ]}
                                        getFriendlyNameForOptions={(option) => option.text}
                                        getUniqueValueForOption={(option) => option.value}
                                        value={config.libraryImportShouldUpdateSummaryRows ? 
                                            { text: this.localizeString('Yes, update summary rows with new uploaded data.'), value: 'yes' } :
                                            { text: this.localizeString('No, do not update summary rows.'), value: 'no' }}
                                        onOptionSelected={() => {}}
                                        isDisabled={true}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>{this.localizeString("Should existing material content rows be updated?")}</label>
                                    <DropdownMenu
                                        options={[
                                            { text: this.localizeString('Yes, delete current content rows and replace with imported data.'), value: 'replace' },
                                            { text: this.localizeString('No, leave existing content rows as-is.'), value: 'leave' }
                                        ]}
                                        getFriendlyNameForOptions={(option) => option.text}
                                        getUniqueValueForOption={(option) => option.value}
                                        value={config.libraryImportNonSummaryRowsMode === LibraryImportNonSummaryRowsModeType.ReplaceNonSummaryRows ? 
                                            { text: this.localizeString('Yes, delete current content rows and replace with imported data.'), value: 'replace' } :
                                            { text: this.localizeString('No, leave existing content rows as-is.'), value: 'leave' }}
                                        onOptionSelected={() => {}}
                                        isDisabled={true}
                                    />
                                </div>
                            </div>
                        )}
                        
                        <RadioButton
                            name={this.localizeString('Import Conflicts as New Products/Materials with Updated Names (e.g. "My Product (2)")')}
                            value={LibraryImportExistingInventoryModeType.WriteNewWithUniquifiedName}
                            selected={config.libraryImportExistingInventoryMode === LibraryImportExistingInventoryModeType.WriteNewWithUniquifiedName}
                            onValueChange={() => {}}
                            disabled={true}
                        />
                        
                        <RadioButton
                            name={this.localizeString("Skip any Import Conflicts - don't import data that references existing products/materials")}
                            value={LibraryImportExistingInventoryModeType.SkipExisting}
                            selected={config.libraryImportExistingInventoryMode === LibraryImportExistingInventoryModeType.SkipExisting}
                            onValueChange={() => {}}
                            disabled={true}
                        />
                        
                        {(config.libraryImportExistingInventoryMode === undefined || config.libraryImportExistingInventoryMode === null) && (
                            <div className="alert alert-warning">
                                <strong>{this.localizeString("No conflict resolution strategy specified.")}</strong>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export const ImportLibrarySettingsPanel = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ImportLibrarySettingsPanelComponent);
